// useLoyaltyRoute.js
import { useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  setState as setPropsState,
  toggleMobileCart,
} from 'containers/Home/actions';
import { defaultHomePropsState } from 'constants/common';

export const useLoyaltyRoute = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const storedOrderId = useRef(null);
  const storedReferralId = useRef(null);
  const [isLoyalty, setIsLoyalty] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const orderIdFromUrl = searchParams.get('orderId');
    const referralIdFromUrl = searchParams.get('refId');

    if (!storedOrderId.current && orderIdFromUrl) {
      storedOrderId.current = orderIdFromUrl;
    }

    if (!storedReferralId.current && referralIdFromUrl) {
      storedReferralId.current = referralIdFromUrl;
    }

    const isLoyaltyPath = location.pathname === '/loyalty';
    setIsLoyalty(isLoyaltyPath);

    // Handle /loyalty route - open loyalty screen
    if (isLoyaltyPath) {
      dispatch(toggleMobileCart(true));
      dispatch(
        setPropsState({
          ...defaultHomePropsState,
          loyaltyOpen: true,
        })
      );
    }
  }, [location, dispatch]);

  return {
    isLoyalty,
    orderId: storedOrderId.current,
    referralId: storedReferralId.current,
  };
};
